import React from 'react'
import { MultiSelect } from 'primereact/multiselect'
import utils from '../../../utils/index'
import LtsMultiselectUnidade from '../../../components/lottus/lts-multiselect-unidade'

/**
 * noAgendamento: o formulario dentro do dialogo de agendamento (AgendarRelatorioDialog), sem seguir a unidade
 * escolhida no topo.
 */
export const IsentosRelatorioForm = (props) => {
  const record = props.record

  return (
    <div>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <LtsMultiselectUnidade
                  name="unidade"
                  label="Unidade"
                  value={record.unidade}
                  onChange={(e) => props.onChangeUnit(e)}
                  ignorarUnidadeDoTopo={props.noAgendamento}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
                <label className="label">Tipo de Sepultura</label>
                <MultiSelect
                  value={record.tiposSepulturas}
                  options={utils.convertArrayIdValueToIdLabel(record.opcoesTiposSepulturas)}
                  name="tiposSepulturas"
                  optionLabel="label"
                  dataKey="id"
                  selectedItemsLabel="{0} itens selecionados"
                  onChange={props.changeHandler}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
